import React from "react";
import { TwConfirmDialog } from "../../components/tailwind";


export default function WarningDialog({ open, text, btnCloseText = "No", isCloseBtn = true, onClose, btnSubmitText = "Yes", isSubmitBtn = true, onSubmit }) {
  return (
    <TwConfirmDialog
      dialogOpen={open}
      isCloseBtn={isCloseBtn}
      btnCloseText={btnCloseText}
      isConfirmBtn={isSubmitBtn}
      btnConfirmText={btnSubmitText}
      dialogType="warning"
      dialogTitle="WARNING"
      dialogMessage={text}
      onClose={onClose}
      onConfirm={onSubmit}
    />
  )
}
